import type { CoachingPartnership } from '@efdigital/ll-addon-data';
import { loadSharesForPartnership } from '@efdigital/ll-xceed-v2/data/builders/coaching/coaching-shared-resources';
import type { SharedResourceItem } from '@efdigital/ll-xceed-v2/data/types/coaching-shared-resource';
import type {
  CoacheeEngagement,
  CoachingCoachCoacheesCoacheeModel,
} from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees/coachee';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

export type CoachingCoachCoacheesCoacheeResourcesModel =
  CoachingCoachCoacheesCoacheeModel & {
    items: SharedResourceItem[];
    defaultPartnership: CoachingPartnership | null;
  };

export default class CoachingCoachCoacheesCoacheeResourcesRoute extends Route<CoachingCoachCoacheesCoacheeResourcesModel> {
  @service declare store: Store;

  async model(): Promise<CoachingCoachCoacheesCoacheeResourcesModel> {
    const parent = this.modelFor(
      'coaching.coach.coachees.coachee'
    ) as CoachingCoachCoacheesCoacheeModel;

    const pages = await Promise.all(
      parent.engagements.map((engagement: CoacheeEngagement) =>
        loadSharesForPartnership(this.store, engagement.partnership.id!)
      )
    );

    return {
      ...parent,
      items: pages.flat(),
      defaultPartnership: parent.engagements[0]?.partnership ?? null,
    };
  }
}
